module.exports = __webpack_public_path__ + "static/media/plant-sad.06d3e147.png";